/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-explicit-any,array-callback-return */
import _has from 'lodash/has';
import _set from 'lodash/set';
import _get from 'lodash/get';
import _unset from 'lodash/unset';

import * as uiToSdk from '../../adapter/style-adapters/ui-sdk';
import * as sdkToUI from '../../adapter/style-adapters/sdk-ui';
import ElementBaseConvert from './elementBaseConvert';
import ChangesetHelper from '@src/slide/domain/ui-model/changesetManager/changesetHelper';
import { convertStyle } from '../../adapter/style-adapters/sdk-ui';
import { Locks } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import {
    setLangFromText,
    splitTextByLanguage,
} from '@src/slide/domain/ui-model/element-modeles/property/text/utils/language';
import { cloneDeep } from '@tencent/slide-sdk-model/src/utils/clone-deep';
import expect from '@src/slide/infrastructure/module/independent/assert/expect';
import ImageEffectConvert from '../../adapter/style-adapters/image-effect-convert';

export const DEFAULT_TEXT_TYPE = 'run';

export default class ShapeConvert extends ElementBaseConvert {
    /**
     *
     * @param sdkData       用于转换使用的SDK 数据 不一定是binding 的SDK 数据
     * @param uiData        转换到的目标的UImodel 数据
     * @param rawSdkData    UIModel binding 的SDK 数据
     */
    public static convertDataSdkToUi(sdkData, uiData, csData) {
        super.convertDataSdkToUi(sdkData, uiData, csData);

        //
        // 首次或者检测到changeset变更时才解析数据
        //
        if (ChangesetHelper.dataHasChangeAtPath(csData, 'props.txBox')) {
            if (_has(sdkData, 'props.txBox')) {
                _set(uiData, 'props.subType', sdkData.props.txBox);
                _set(uiData, 'props.style.subType', sdkData.props.txBox); // style也挂上
            }
        }

        // bg-shape
        if (ChangesetHelper.dataHasChangeAtPath(csData, 'props.prstGeom')) {
            if (_has(sdkData, 'props.prstGeom')) {
                sdkToUI.addBgShape(sdkData.props.prstGeom, uiData.props.style);
            }
        }

        // custom-shape
        if (ChangesetHelper.dataHasChangeAtPath(csData, 'props.customGeom')) {
            if (_has(sdkData, 'props.customGeom')) {
                sdkToUI.addCustomShape(sdkData.props.customGeom, uiData.props.style);
            } else {
                // placeholder 设置草绘格式不会改变 prstGeom， 所以需要在 customGeom 变化时做额外判断
                if (_get(uiData, 'props.style.bgShape') === 'custom'
                    && _has(sdkData, 'props.prstGeom')
                    && (expect(csData.props.customGeom).isNullOrUndefined()
                        || Object.keys(csData.props.customGeom).length === 0)
                ) {
                    sdkToUI.addBgShape(sdkData.props.prstGeom, uiData.props.style);
                }
            }
        }

        if (ChangesetHelper.dataHasChangeAtPath(csData, 'textBody.props')) {
            if (_has(sdkData, 'textBody.props')) {
                // TODO vert
                _set(uiData, 'textBodyStyle', sdkToUI.convertStyle(sdkData.textBody.props));
            }
        }

        ShapeConvert.checkAddSpLocks(csData, sdkData, uiData);

        if (_has(sdkData, 'props.attachment')) {
            _set(uiData, 'props.attachment', sdkData.props.attachment);
        }

        _set(uiData, 'props.paragraphStyle', 'Heading 1'); // TODO

        ShapeConvert.convertParagraphDataSdkToUi(sdkData, uiData, csData);

        ShapeConvert.convert3DDataSdkToUi(sdkData, uiData);

        // 当形状设置图片填充时，即拥有图片属性
        const blip = sdkData?.props?.background?.image?.blip;
        if (blip) {
            ImageEffectConvert.convertImageBlipDataSdkToUi(blip, uiData);
        }
    }

    /**
     *
     * @param uiData        需要转换的UI数据，UIModel的子集
     * @param sdkData       转换到的目标数据
     * @param rawUiModel    完整的UIModel对象
     */
    public static convertDataUiToSdk(uiData, sdkData, rawUiData) {
        super.convertDataUiToSdk(uiData, sdkData, rawUiData);
        // position
        if (_has(uiData, 'props.style')) {
            uiToSdk.addTransform(uiData.props.style, sdkData, 'props.frame');
        }

        if (_has(uiData, 'props.subType')) {
            _set(sdkData, 'props.txBox', uiData.props.subType);
        }

        // bg-shape
        ShapeConvert.convertGeomDataUiToSdk(uiData, sdkData);

        if (_has(uiData, 'textBodyStyle') && uiData.textBodyStyle) {
            const props = uiToSdk.convertStyle(uiData.textBodyStyle);
            props && _set(sdkData, 'textBody.props', props);
        }

        if (_has(uiData, 'props.locks')) {
            _set(sdkData, Locks.LOCKS, uiData.props[Locks.LOCKS]);
        }

        if (_has(uiData, 'props.attachment')) {
            const attachmentData = uiToSdk.convertAttachment(uiData.props.attachment);
            _set(sdkData, 'props.attachment', attachmentData);
        }

        ShapeConvert.convertParagraphDataUiToSdk(uiData, sdkData);

        ShapeConvert.convert3DDataUiToSdk(uiData, sdkData);

        // 当形状设置图片填充时，即拥有图片属性
        ImageEffectConvert.convertImageEffectDataUiToSdk(uiData, sdkData, 'props.background');
    }

    private static convertParagraphDataSdkToUi(sdkData, uiData, csData) {
        // 母版、版式上有部分占位符有 textStyleList，样式不在 run.props 上，所以 textStyleList 变更时也需要更新
        if (ChangesetHelper.dataHasChangeAtPath(csData, 'textBody.paragraphList')
            || ChangesetHelper.dataHasChangeAtPath(csData, 'textBody.textStyleList')) {
            if (_has(sdkData, 'textBody.textStyleList')) {
                _set(uiData, 'textStyleList', sdkData.textBody.textStyleList);
            }
            ShapeConvert.convertParagraphListSdkToUi(sdkData, uiData);
        }
    }

    private static convertParagraphListSdkToUi(sdkData: any, uiData: any) {
        if (_has(sdkData, 'textBody.paragraphList')) {
            const pList = sdkData.textBody.paragraphList;

            const paragraphList = pList.map((p) => {
                const para: any = {};

                para.paragraphProps = {};

                // 母版、版式上有部分占位符有 textStyleList，可能没有 defaultRunProps，所以需要合并一下，详情查看 getExtendStyleList
                if (uiData.textStyleList && uiData.isMasterLayoutPl)  {
                    const levelStyle = ShapeConvert.findLevelStyleFromTextStyleList(uiData.textStyleList, p);
                    const cloneLevelStyle = cloneDeep(levelStyle);
                    _unset(cloneLevelStyle, 'defaultRunProps');
                    p.paragraphProps = Object.assign({}, cloneLevelStyle, p.paragraphProps);
                }

                // para style
                if (_has(p, 'paragraphProps')) {
                    para.paragraphProps = {
                        ...para.paragraphProps,
                        ...sdkToUI.convertStyle(p.paragraphProps),
                    };

                    // 这是一件很蠢的事情，但是为了能转化回来...
                    if (_has(p.paragraphProps, 'level')) para.paragraphProps.level = p.paragraphProps.level;
                    if (_has(p.paragraphProps, 'defaultRunProps')) para.paragraphProps.defaultRunProps = convertStyle(p.paragraphProps.defaultRunProps);
                    para.paragraphCharacter = sdkToUI.convertCharacter(p.paragraphProps);
                }

                // textrun
                if (_has(p, 'paragraphItem')) {
                    para.textRuns = [];
                    p.paragraphItem
                        .map((run) => {
                            // 母版、版式上有部分占位符有 textStyleList，可能没有 run.props，所以需要合并一下，详情查看 getExtendStyleList
                            if (uiData.textStyleList && uiData.isMasterLayoutPl) {
                                const levelStyle = ShapeConvert
                                    .findLevelStyleFromTextStyleList(uiData.textStyleList, para);
                                if (levelStyle?.defaultRunProps) {
                                    run.props = Object.assign({}, cloneDeep(levelStyle.defaultRunProps), run.props);
                                }
                            }
                            // 软回车
                            if (run.type === 'runBr') {
                                para.textRuns.push({
                                    ...run,
                                });
                            } else if (ShapeConvert.isNoNeedSplitText(run)) {
                                para.textRuns.push(this.convertRunSdkToUi(run, run.text, uiData));
                            } else {
                                // 拆分中英文
                                splitTextByLanguage(run.text)
                                    .map((text) => {
                                        // lang统一设置
                                        para.textRuns.push(this.convertRunSdkToUi(run, text, uiData));
                                    });
                            }
                        });
                }

                // 这里和textRun的处理类似
                if (_has(p, 'endParaRPr')) {
                    para.endParaRPr = sdkToUI.convertStyle(p.endParaRPr);
                    para.endParaRPr.useEndParaStyle = true;
                }
                return para;
            });
            _set(uiData, 'paragraphList', paragraphList);
        }
    }

    private static isNoNeedSplitText(run) {
        return (run.props?.font && (run.props.font.latin?.typeface === run.props.font.ea?.typeface))
            || run.fieldType || run.props?.hlink;   // 存在field暂不进行切割，目前图表数据标签和时间日期都可能存在field
    }

    private static convertRunSdkToUi(run, text, uiData) {
        const textRun: any = {
            text,
            styles: {},
            type: run.type,
        };
        // 因为copy-paste的存在，转换层不会再对attr做任何变动，只保证attr的映射。原有的字体继承与转换逻辑放到editor层做
        // 页眉页脚属性继承
        if (_has(run, 'fieldType')) {
            textRun.fieldType = run.fieldType;
            textRun.fieldId = run.id;
        }
        // style
        if (_has(run, 'props')) {
            textRun.styles = {
                // font-size继承
                ...textRun.styles,
                ...sdkToUI.convertStyle(run.props),
            };
            // 日期类型lang无需转换
            if (!(run.fieldType?.indexOf('datetime') > -1)) {
                setLangFromText(text, textRun.styles);
            }
        }
        return textRun;
    }

    private static convertGeomDataUiToSdk(uiData, sdkData) {
        // bg-shape
        if (_has(uiData, 'props.style.bgShape') || _has(uiData, 'props.style.controlValues')) {
            if (_get(uiData, 'props.style.bgShape') === 'custom') {
                if (_has(uiData, 'props.style.customGeom')) {
                    if (!_has(sdkData, 'props')) _set(sdkData, 'props', {});
                    uiToSdk.addCustomShape(uiData.props.style.customGeom, sdkData.props);
                }
            } else {
                if (!_has(sdkData, 'props.prstGeom')) _set(sdkData, 'props.prstGeom', {});
                uiToSdk.addBgShape(uiData.props.style, sdkData.props.prstGeom);
            }
        }
        if (_has(uiData, 'props.style.customGeom') && expect(uiData?.props?.style?.customGeom).isNullOrUndefined()) {
            _set(sdkData, 'props.customGeom', null);
        }
    }

    private static convertParagraphDataUiToSdk(uiData, sdkData) {
        if (_has(uiData, 'paragraphList')) {
            if (!_has(sdkData, 'textBody.paragraphList')) _set(sdkData, 'textBody.paragraphList', []);
            const sdkTextBody = sdkData.textBody;
            // eslint-disable-next-line complexity
            sdkTextBody.paragraphList = uiData.paragraphList.map((para) => {
                const p: any = {};
                if (_has(para, 'paragraphProps')) {
                    // TODO 抽离逻辑 获取继承而来的line-height
                    p.paragraphProps = uiToSdk.convertStyle(JSON.parse(JSON.stringify(para.paragraphProps)));
                    if (_has(para.paragraphProps, 'level')) p.paragraphProps.level = para.paragraphProps.level;
                    if (_has(para.paragraphProps, 'defaultRunProps')) p.paragraphProps.defaultRunProps = uiToSdk.convertStyle(para.paragraphProps.defaultRunProps);
                }

                if (_has(para, 'textRuns')) {
                    let endParaRPr;
                    p.paragraphItem = para.textRuns
                        .map((textRun, index) => {
                            // 软回车
                            if (textRun.type === 'runBr') {
                                return { ...textRun };
                            }

                            const run: any = {
                                text: textRun.text,
                                type: textRun.type || DEFAULT_TEXT_TYPE,
                            };

                            // fieldType
                            if (_has(textRun, 'fieldType')) {
                                run.fieldType = textRun.fieldType;
                                run.id = textRun.fieldId;
                            }

                            // style
                            if (_has(textRun, 'styles')) {
                                const s = JSON.parse(JSON.stringify(textRun.styles));
                                run.props = uiToSdk.convertStyle(s);

                                // 处理结尾TextRun
                                if (s.useEndParaStyle) {
                                    // run.text = run.text.replace('\uFEFF', ''); // 去掉空字符
                                    if (!run.text && index === para.textRuns.length - 1) { // 尾TextRun没被修改
                                        endParaRPr = run.props;
                                    }
                                }
                            }

                            return run;
                        });
                    // .concat({ type: 'endParaPPr' }); // 结尾标记

                    if (endParaRPr) {
                        p.endParaRPr = endParaRPr;
                    } else if (para.endParaRPr) {
                        p.endParaRPr = uiToSdk.convertStyle(para.endParaRPr);
                    }
                    const pItems = p.paragraphItem.filter(item => item.type === 'runBr' || item.type === 'field' || item.text); // 去除空的textRun

                    if (pItems.length === 0) { // 自己产生的空行,设置endParaRPr并使用空的textRun的样式
                        const emptyTextRun = p.paragraphItem.length > 0 ? p.paragraphItem[0] : null;
                        if (emptyTextRun?.props) {
                            p.endParaRPr = emptyTextRun.props;
                        }
                    }

                    p.paragraphItem = pItems;
                }

                if (_has(para, 'paragraphCharacter')) {
                    p.paragraphProps = {
                        ...p.paragraphProps,
                        ...uiToSdk.convertCharacter(para.paragraphCharacter),
                    };
                }

                return p;
            });
        }
    }

    private static checkAddSpLocks(csData, sdkData, uiData) {
        // 暂时去掉dataHasChangeAtPath判断，待修复之后加上
        // if (ChangesetHelper.dataHasChangeAtPath(csData, Locks.LOCKS)) {
        if (_has(sdkData, Locks.LOCKS)) {
            sdkToUI.addLocks(sdkData, uiData, Locks.LOCKS);
        } else {
            _set(uiData.props, Locks.LOCKS, null);
        }
        // }
    }

    private static findLevelStyleFromTextStyleList(textStyleList, paragraphListItem) {
        return textStyleList?.find(({ level }) => _get(paragraphListItem, 'paragraphProps.level', 0) === level);
    }
}

